<template>
  <v-window-item :value="1" class="pa-3 fill-height">
    <div v-if="!loaded" class="fill-height">
      <div v-if="!loading" class="fill-height">
        <ShapeFileUpload
          @fetchGeometryFieldNames="fetchGeometryFieldNames"
          @updateFieldName="fieldName = $event"
          @updateFileName="fileName = $event"
          :field-name="fieldName"
          :field-names="fieldNames"
          :file-name="fileName"
          :loading-field="loadingField"
        />
      </div>
      <div style="height: 10%" class="py-3">
        <v-btn
          class="float-right"
          :disabled="!fieldName"
          color="primary"
          :loading="uploading"
          @click="uploadFile()"
        >
          Upload & Continue
        </v-btn>
      </div>
    </div>
    <div v-else class="fill-height">
      <v-data-table
        class="overflow-y-auto fill-height"
        density="compact"
        fixed-header
        :items-per-page="-1"
        :items="dikeSections.features"
        :headers="headers"
      >
        <template #bottom> </template>
        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:[`item.properties.color`]="{ item }">
          <SectionChip :item="item" />
        </template>
      </v-data-table>
      <div style="height: 10%" class="py-3">
        <v-btn :loading="loadingDelete" @click="deleteAll" color="error" variant="flat">
          Delete all
        </v-btn>
        <v-btn variant="flat" class="float-right" color="primary" @click="$emit('continue')">
          Continue
        </v-btn>
      </div>
    </div>
  </v-window-item>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ShapeFileUpload from '@/components/dike/ShapeFileUpload.vue'
import api from '../../api/api'
import SectionChip from '@/components/dikeSection/SectionChip.vue'

export default {
  name: 'DikeSectionUploadShapeFileStep',
  components: { SectionChip, ShapeFileUpload },
  props: {
    step: {}
  },
  data: () => ({
    fileName: null,
    fieldNames: [],
    fieldName: null,
    uploading: false,
    loadingField: false,
    loadingDelete: false,
    headers: [
      { title: '', value: 'properties.color' },
      { title: 'Index', value: 'index' },
      { title: 'Dike section', value: 'properties.name' }
    ]
  }),
  computed: {
    ...mapState('project', {
      currentProject: (state) => state.currentProject
    }),
    ...mapState('dikeSection', {
      loading: (state) => state.loading,
      loaded: (state) => state.loaded,
      dikeSections: (state) => state.items
    })
  },
  methods: {
    ...mapActions('dikeSection', {
      uploadDikeSections: 'upload',
      deleteDikeSections: 'deleteAll'
    }),
    async uploadFile() {
      this.uploading = true
      const formData = new FormData()
      const file = this.fileName
      formData.append('file', file, file.name)
      formData.append('field', this.fieldName)
      try {
        await this.uploadDikeSections(formData)
        this.$emit('continue')
      } catch (e) {
        console.log(e)
        this.uploading = false
      }
      this.uploading = false
    },
    resetSelectField: function () {
      this.loadingField = false
      this.fieldNames = []
      this.fieldName = null
    },
    async deleteAll() {
      this.loadingDelete = true
      await this.deleteDikeSections()
      this.loadingDelete = false
    },
    async fetchGeometryFieldNames() {
      this.loadingField = true
      const formData = new FormData()
      if (!this.fileName) {
        return this.resetSelectField()
      } else {
        const file = this.fileName
        formData.append('file', file, this.fileName.name)
        await api
          .post(`/dike_sections/get_field_names/`, formData)
          .then((response) => {
            this.fieldNames = response.data
          })
          .catch((error) => {
            console.log(error)
            this.loadingField = false
          })

        this.loadingField = false
      }
    }
  }
}
</script>
<style scoped></style>
